import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { OrganizationLookupModel } from 'core/models/organization-lookup.model';

@Injectable({
    providedIn: 'root',
})
export class ApiOrganizationByRoleLookupService extends ApiListDataService<
    OrganizationLookupModel,
    any
> {
    constructor(http: HttpClient) {
        super(http, '/Organization/ByRoleLookup');
    }
}
